import { api } from '@/api';

const createQuestionnaire = (questionnaire) => {
  return api.post('/api/kyc/v1/editingQuestionnaires/questionSectionType', { ...questionnaire });
};
const updateQuestionnaire = (questionnaire) => {
  return api.put('/api/kyc/v1/editingQuestionnaires/questionSectionType', {
    ...questionnaire,
    questionSectionTypeId: questionnaire.id
  });
};

const deleteQuestionnaire = (questionnaire) => {
  return api.delete('/api/kyc/v1/editingQuestionnaires/questionSectionType', {
    data: { questionSectionTypeId: questionnaire.id }
  });
};

const createSection = (section, questionSectionTypeId) => {
  return api.post('/api/kyc/v1/editingQuestionnaires/questionSection', {
    questionSectionTypeId: questionSectionTypeId,
    section: section.section,
    newNumber: Number(section.newNumber),
    visibleConditions: section.visibleConditions,
    visibleOperator: section.visibleOperator
  });
};
const updateSection = (section) => {
  return api.put('/api/kyc/v1/editingQuestionnaires/questionSection', {
    questionSectionId: section.id,
    section: section.section,
    newNumber: Number(section.newNumber),
    visibleConditions: section.visibleConditions,
    visibleOperator: section.visibleOperator
  });
};
const updateSectionOrder = ({ id, newNumber }) => {
  return api.put('/api/kyc/v1/editingQuestionnaires/questionSection', {
    questionSectionId: id,
    newNumber: Number(newNumber)
  });
};
const deleteSection = (section) => {
  return api.delete('/api/kyc/v1/editingQuestionnaires/questionSection', {
    data: { questionSectionId: section.id }
  });
};

const createGroup = (group, sectionId) => {
  return api.post('/api/kyc/v1/editingQuestionnaires/questionGroup', {
    questionSectionId: sectionId,
    title: group.title,
    isMultiple: group.isMultiple,
    multipleMin: group.multipleMin,
    multipleMax: group.multipleMax,
    sortOrder: group.sortOrder,
    visibleConditions: group.visibleConditions,
    visibleOperator: group.visibleOperator
  });
};
const updateGroup = (group) => {
  return api.put('/api/kyc/v1/editingQuestionnaires/questionGroup', {
    questionGroupId: group.id,
    title: group.title,
    isMultiple: group.isMultiple,
    multipleMin: group.multipleMin,
    multipleMax: group.multipleMax,
    sortOrder: group.sortOrder,
    visibleConditions: group.visibleConditions,
    visibleOperator: group.visibleOperator,
    addToPdf: group.addToPdf
  });
};
const updateGroupOrder = ({ id, sortOrder }) => {
  return api.put('/api/kyc/v1/editingQuestionnaires/questionGroup', {
    questionGroupId: id,
    sortOrder: sortOrder
  });
};
const deleteGroup = (group) => {
  return api.delete('/api/kyc/v1/editingQuestionnaires/questionGroup', {
    data: { questionGroupId: group.id }
  });
};

const createQuestion = (question, groupId) => {
  return api.post('/api/kyc/v1/editingQuestionnaires/question', {
    questionGroupId: groupId,
    question: question.question,
    type: question.type,
    tooltip: question.tooltip,
    tooltip_RU: question.tooltip_RU,
    tooltip_LV: question.tooltip_LV,
    isRequired: question.isRequired,
    sortOrder: question.sortOrder,
    visibleConditions: question.visibleConditions,
    visibleOperator: question.visibleOperator,
    preFilledValue: question.preFilledValue,
    dateForSelect: question.dateForSelect,
    person: question.person,
    company: question.company,
    minCountSymbols: question.minCountSymbols,
    maxCountSymbols: question.maxCountSymbols,
    countFirstLetterSymbolsCountry: question.countFirstLetterSymbolsCountry,
    sumConditions: question.sumConditions
  });
};
const updateQuestion = (question) => {
  return api.put('/api/kyc/v1/editingQuestionnaires/question', {
    questionId: question.id,
    question: question.question,
    type: question.type,
    tooltip: question.tooltip,
    tooltip_RU: question.tooltip_RU,
    tooltip_LV: question.tooltip_LV,
    isRequired: question.isRequired,
    sortOrder: question.sortOrder,
    visibleConditions: question.visibleConditions,
    visibleOperator: question.visibleOperator,
    preFilledValue: question.preFilledValue,
    dateForSelect: question.dateForSelect,
    person: question.person,
    company: question.company,
    minCountSymbols: question.minCountSymbols,
    maxCountSymbols: question.maxCountSymbols,
    countFirstLetterSymbolsCountry: question.countFirstLetterSymbolsCountry,
    addToPdf: question.addToPdf,
    onlyLatin: question.onlyLatin,
    sumConditions: question.sumConditions
  });
};

const updateQuestionOrder = ({ id, sortOrder }) => {
  return api.put('/api/kyc/v1/editingQuestionnaires/question', {
    questionId: id,
    sortOrder: sortOrder
  });
};
const deleteQuestion = (question) => {
  return api.delete('/api/kyc/v1/editingQuestionnaires/question', {
    data: { questionId: question.id }
  });
};

const createAnswer = (answer, questionId) => {
  return api.post('/api/kyc/v1/editingQuestionnaires/availableAnswer', {
    questionId: questionId,
    answer: answer.answer,
    sortOrder: answer.sortOrder,
    points: answer.points,
    pointsScoring: answer.pointsScoring
  });
};
const updateAnswer = (answer) => {
  return api.put('/api/kyc/v1/editingQuestionnaires/availableAnswer', {
    availableAnswerId: answer.id,
    answer: answer.answer,
    sortOrder: answer.sortOrder,
    points: answer.points,
    pointsScoring: answer.pointsScoring
  });
};
const updateAnswerScoringCategory = ({ availableAnswerId, categoryScoringId }) => {
  return api.put('/api/kyc/v1/editingQuestionnaires/availableAnswer', {
    availableAnswerId,
    categoryScoringId
  });
};
const updateAnswerOrder = ({ id, sortOrder }) => {
  return api.put('/api/kyc/v1/editingQuestionnaires/availableAnswer', {
    availableAnswerId: id,
    sortOrder: sortOrder
  });
};
const deleteAnswer = (answer) => {
  return api.delete('/api/kyc/v1/editingQuestionnaires/availableAnswer', {
    data: { availableAnswerId: answer.id }
  });
};
const addDocumentType = (questionSectionTypeId, kycTypeDocumentId) => {
  return api.post('/api/kyc/v1/editingQuestionnaires/questionSectionType/documents', {
    questionSectionTypeId: questionSectionTypeId,
    kycTypeDocumentId: kycTypeDocumentId
  });
};
const deleteDocumentType = (questionSectionTypeId, kycTypeDocumentId) => {
  return api.delete('/api/kyc/v1/editingQuestionnaires/questionSectionType/documents', {
    data: {
      questionSectionTypeId: questionSectionTypeId,
      kycTypeDocumentId: kycTypeDocumentId
    }
  });
};

const getRelatedQuestionnaire = ({ questionSectionTypeId }) => {
  return api.get('/api/kyc/v1/editingQuestionnaires/questionSectionType/relatedQuestionnaire', {
    params: { questionSectionTypeId }
  });
};

const createRelatedQuestionnaire = (questionSectionTypeId, groupId, conditions, questions) => {
  return api.post('/api/kyc/v1/editingQuestionnaires/questionSectionType/relatedQuestionnaire', {
    questionSectionTypeId: questionSectionTypeId,
    groupId: groupId,
    conditions: conditions,
    questions: questions
  });
};
const deleteRelatedQuestionnaire = (relatedQuestionnaireId) => {
  return api.delete('/api/kyc/v1/editingQuestionnaires/questionSectionType/relatedQuestionnaire', {
    data: {
      relatedQuestionnaireId: relatedQuestionnaireId
    }
  });
};

const createComment = (categoryScoringId, comment) => {
  return api.post('/api/kyc/v1/admin/scoring/category/comment', {
    categoryScoringId,
    ...comment
  });
};

const updateComment = (commentId, comment) => {
  return api.put('/api/kyc/v1/admin/scoring/category/comment', {
    commentId,
    ...comment
  });
};

const deleteComment = (commentId) => {
  return api.delete('/api/kyc/v1/admin/scoring/category/comment', {
    data: { commentId }
  });
};

export const ConstructorApi = {
  createQuestionnaire,
  updateQuestionnaire,
  deleteQuestionnaire,
  createSection,
  updateSection,
  updateSectionOrder,
  deleteSection,
  createGroup,
  updateGroup,
  updateGroupOrder,
  deleteGroup,
  createQuestion,
  updateQuestion,
  updateQuestionOrder,
  deleteQuestion,
  createAnswer,
  updateAnswer,
  updateAnswerScoringCategory,
  updateAnswerOrder,
  deleteAnswer,
  addDocumentType,
  deleteDocumentType,
  getRelatedQuestionnaire,
  createRelatedQuestionnaire,
  deleteRelatedQuestionnaire,
  createComment,
  updateComment,
  deleteComment
};
